"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _CSSTransitionGroup = _interopRequireDefault(require("react-transition-group/CSSTransitionGroup"));

var _styled = require("./styled.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FadeIn = function FadeIn(props) {
  return _react["default"].createElement(_styled.FadeInContainer, null, _react["default"].createElement(_CSSTransitionGroup["default"], {
    transitionName: "fadeIn",
    transitionAppear: true,
    transitionAppearTimeout: props.appear || 300,
    transitionEnterTimeout: props.enter || 300,
    transitionLeaveTimeout: props.leave || 300,
    className: "transitionWrapper ".concat(props.className || ''),
    component: props.component || 'span'
  }, props.children));
};

var _default = FadeIn;
exports["default"] = _default;

//# sourceMappingURL=FadeIn.js.map